import { useCreation } from 'ahooks';
import React, { useRef, useState } from 'react';
import dayjs from '../_util/day';
import { pickDomAttrs } from '../_util/utils';
import DatePicker from '../date-picker';
import { jsx as _jsx } from "react/jsx-runtime";
export const TimeRangePicker = _ref => {
  let {
    defaultValue,
    ranges,
    onChange,
    showTime,
    // 默认设置了showTime格式，传false的时候不展示，否则使用默认格式
    className,
    style,
    ...restProps
  } = _ref;
  const attrs = pickDomAttrs(restProps);
  const _ranges = useCreation(() => {
    if (!(ranges !== null && ranges !== void 0 && ranges.length)) {
      return undefined;
    }
    return {
      defaultValue: defaultValue ? defaultValue : typeof ranges[0].value === 'function' ? ranges[0].value() : ranges[0].value,
      options: ranges.reduce((acc, cur) => {
        acc[cur.name] = cur.value;
        return acc;
      }, {})
    };
  }, [ranges]);
  const newValue = useRef();
  const [value, setValue] = useState(_ranges !== null && _ranges !== void 0 && _ranges.defaultValue ? [_ranges.defaultValue[0].toJSON(), _ranges.defaultValue[1].toJSON()] : undefined);
  return /*#__PURE__*/_jsx("div", {
    ...attrs.data,
    className: className,
    style: {
      width: 360,
      ...style
    },
    children: /*#__PURE__*/_jsx(DatePicker, {
      size: "s",
      type: "outline",
      width: "100%",
      allowClear: false,
      getPopupContainer: trigger => trigger.parentNode,
      defaultValue: _ranges === null || _ranges === void 0 ? void 0 : _ranges.defaultValue,
      showTime: showTime ? {
        defaultValue: [dayjs('00:00:00', 'HH:mm'), dayjs('23:59:59', 'HH:mm')],
        showSecond: false,
        hideDisabledOptions: true
      } : false,
      picker: "date",
      rangePicker: true,
      disabledDate: current => current.isAfter(dayjs().endOf('day')),
      ranges: _ranges === null || _ranges === void 0 ? void 0 : _ranges.options,
      onChange: val => {
        const [start, end] = val !== null && val !== void 0 ? val : [];
        if (start && end) {
          newValue.current = [start.startOf(showTime ? 'minute' : 'day').toJSON(), end.endOf(showTime ? 'minute' : 'day').toJSON()];
        }
      },
      onOpenChange: opened => {
        if (!opened && newValue.current && (newValue.current[0] !== (value === null || value === void 0 ? void 0 : value[0]) || newValue.current[1] !== (value === null || value === void 0 ? void 0 : value[1]))) {
          setValue(newValue.current);
          onChange(newValue.current);
        }
        newValue.current = undefined;
      }
    })
  });
};